export const SECTION_IDS = {
  INTRO: 0,
  LOGO_WALL: 1,
  OVERLAY: 2,
}

export const CONTENT_IDS = {
  GALLERY: 0,
  CONSULTING: 1,
  CONVERSATION: 2,
  GTN: 3,
  STAUDINGER: 4,
  LANZENAUER: 5,
}

export const EVENT = {
}
